import React from 'react';
import PropTypes from 'prop-types';
import { SuiButton, SuiTooltipPopover } from '@splashthat/sui';
import EyeIcon from 'common/icons/Eye';

import { EventPreviewTooltipStyles } from './EventPreviewButton.styles';

const PREVIEW = 'Preview Attendee View';

function EventPreviewButton({ className }) {
    return (
        <>
            <EventPreviewTooltipStyles />
            <SuiTooltipPopover align="center" content={<label>{PREVIEW}</label>}>
                <SuiButton
                    aria-label={PREVIEW}
                    className={className}
                    icon={EyeIcon}
                    variation="overlay-light"
                    size="small"
                />
            </SuiTooltipPopover>
        </>
    );
}

EventPreviewButton.propTypes = {
    className: PropTypes.string,
};

EventPreviewButton.defaultProps = {
    className: '',
};

export default EventPreviewButton;
